export default {
  introduce: {
    title: '新しい課金モデルを導入',
    cost: '素材インプレッション課金',
    limit: 'トップ50',
    gift: '情報を記入してパッケージを申請',
    describe:
      '最初の50名様は初回チャージ完了後、特別な新規ユーザーパッケージがもらえます。',
  },
  form: {
    name: 'お名前を入力してください',
    email: 'メールアドレスを入力してください',
    validate: 'メールアドレスの形式が正しくありません',
    remark: 'メッセージをお願いします',
    send: '申し込む',
    success:
      'お問い合わせいただきありがとうございます。すぐに担当からご連絡差し上げます。',
  },
  suggest: {
    chargMode: {
      title: '課金モデル',
      describe:
        'Mintegralチャネル上のクリエイティブのインプレッション回数に基づいて請求されます',
    },
    cpmPrice: {
      title: 'CPM単価',
      describe: '単一の素材に対し、1,000インプレッションごとに$0.5ドル',
    },
    cappMechanism: {
      title: '上限メカニズム',
      describe: '各素材の費用は800ドルで上限があり、それ以上の課金はありません',
    },
    minRecharge: {
      title: 'ミニマムリチャージ',
      describe:
        '最低金額は800ドルで、これは広告の配信の継続性と安定性を確保するための前払いです。',
    },
  },
  problem: {
    title: 'よくある質問',
    question1: '広告費用の課金モデルはすべてのチャネルに適していますか？',
    question2: 'CPM費用はどのように計算されますか？',
    question3: '800ドルを超えた場合はどうなりますか？',
    question4:
      'ミニマムリチャージはいくらですか？請求はどのように計算されますか？',
    main: {
      content1:
        '当社の広告費用の課金モデルは、素材のインプレッション数に基づいており、現在はMintegralのみをサポートしています。',
      content2:
        '単一の素材につき、1,000回のインプレッションごとに0.5ドルの費用がかかります。つまり、広告素材が1,000回表示されるたびに0.5ドルの費用が請求されます。',
      content3:
        '広告主の利益を保護するため、一つの素材に対して最高費用の上限を設定しています。単一の広告素材のインプレッション数が160万回を超える場合、つまり800ドルの上限に達した場合、それ以上の費用は発生しなくなります。つまり、表示数がどれだけ多くても、一つの素材の費用は上限額を超えることはありません。',
      content4:
        '当社の広告サービスを利用するために、個別の広告主は最低800ドルの入金が必要です。これは、広告プレースメントの継続性と安定性を保証するための前払いデポジットとなります。',
      example: {
        describe: '例：',
        title:
          '異なる月に同時にプレイアブル素材を配置した例で説明します。各月の課金シナリオは以下の通りです。',
        October: {
          title: '10月には素材A、B、C、Dが作成され、配信されました：',
          materialA: '素材A：50万回のインプレッション',
          materialB: '素材B：45万回のインプレッション',
          materialC: '素材C：60万回のインプレッション',
          materialD: '素材D：55万回のインプレッション',
          cost: '10月の費用計算：',
          materialACost:
            '素材Aの費用：50万回のインプレッション ÷ 1,000 × 0.5ドル/CPM = 250ドル',
          materialBCost:
            '素材Bの費用：45万回のインプレッション ÷ 1,000 × 0.5ドル/CPM = 225ドル',
          materialCCost:
            '素材Cの費用：60万回のインプレッション ÷ 1,000 × 0.5ドル/CPM = 300ドル',
          materialDCost:
            ' 素材Dの費用：55万回のインプレッション ÷ 1,000 × 0.5ドル/CPM = 275ドル ',
          totalCost:
            '10月の総費用：250ドル + 225ドル + 300ドル + 275ドル = 1,050ドル',
        },
        November: {
          title:
            '11月には、素材AとBの表示は継続され、素材CとDの表示は停止し、新たに素材EとFが作成されて表示が開始されました：',
          materialA:
            '素材A：120万回のインプレッション（10月と11月の両方の表示を含む）',
          materialB: '素材B：5.8万回のインプレッション',
          materialE: '素材E：5.3万回のインプレッション',
          materialF: '素材F：4.8万回のインプレッション',
          cost: '11月の費用計算：',
          materialACost:
            '素材Aの費用: 素材Aは10月から累計で表示回数が160万回を超えています（50,000 + 1,200,000 = 1,700,000）。したがって、今月の費用は(1,600,000 - 500,000)回 ÷ 1000回 × 0.5ドル/CPM = 550ドルです。',
          materialBCost:
            '素材Bの費用: 58,000回 ÷ 1000回 × 0.5ドル/CPM = 29ドル',
          materialECost:
            '素材Eの費用: 53,000回 ÷ 1000回 × 0.5ドル/CPM = 26.5ドル',
          materialFCost:
            '素材Fの費用: 48,000回 ÷ 1000回 × 0.5ドル/CPM = 24ドル',
          totalCost:
            '11 月の総費用: 550ドル + 29ドル + 26.5ドル + 24ドル = 629.5ドル',
        },
        tips: '*各月のコスト計算では、各素材のインプレッション量を考慮し、各素材のコストを合計して総コストを算出することにご留意ください。キャップ・メカニズムは個々の素材に適用され、そのコストが上限額を超えないようにします。',
      },
    },
  },
  bottom: '*キャンペーンの解釈権は Mindworks、Mintegral に帰属します',
}
